import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SftpConfigPage } from './SftpConfigPage';
import { SftpLogsPage } from './SftpLogsPage';

export const SftpSyncModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="config" replace />} />
      <Route path="config" element={<SftpConfigPage />} />
      <Route path="logs" element={<SftpLogsPage />} />
    </Routes>
  );
};